import FaveControl from './FaveControl';
import FaveControlContainer from './FaveControl.container';
export default FaveControlContainer(FaveControl);
//# sourceMappingURL=index.js.map